import React, { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { connect } from 'react-redux';

import FinancingsSearchTable from './components/FinancingsSearchTable';
import Alert from '../../shared/components/Alert';
import TrialAlert from '../../shared/components/payment/TrialAlert';
import AlertIcon from 'mdi-react/InformationOutlineIcon';
import EnterpriseGate from '../../shared/components/payment/EnterpriseGate';
import { _hasPermission } from "../../shared/helpers/access";

import { isMobile } from "react-device-detect";

class Financings extends React.Component {
	render() {
		const { user, isShare } = this.props;
		if (!user) return null;

		return (
			<Container>
				<Row className="c_seconday-nav-container">
					<Col md={12}>
						<h3 className="page-title">Search Financings</h3>
						{!isMobile && <h3 className="page-subhead subhead">Search mortgages, assignments, satisfactions & related financing documents</h3>}
					</Col>
				</Row>
				{isShare || _hasPermission(user, 'finance-tab') ?
					<Fragment>
						<Row>
							<Col md={12} className={'mb-3'}>
								<TrialAlert />
							</Col>
						</Row>
						<Row id="research_bar">
							<Col md={12} className={'mb-3'}>
								<Alert color="success" className="alert--bordered" alertId="aboutFinancingsData" icon iconItem={<AlertIcon />} minimizeText={`About The Data`}>
									<p>
										<span className="bold-text">{`About The Data`}</span>
										<div>{`Financing records are sourced from ACRIS and are provisional; some records may lag or be reclassified as they are vetted.`}</div>
									</p>
								</Alert>
							</Col>
						</Row>

						<Row>
							<FinancingsSearchTable />
						</Row>
					</Fragment>
					:
					<Row>
						<EnterpriseGate
							copy={<span>Access to Financings requires an upgrade to your subscription.</span>}
							upgrade={false}
							user={user}
							img={`https://marketproof.com/svgs/PL1.svg`}
							classes={"small-image"}
						/>
					</Row>
				}
			</Container>
		);
	}
}

export default connect(state => ({
	user: state.user,
}))(Financings);
